module.exports = __webpack_public_path__ + "static/media/c24.31127cfc.png";